import script from "./MyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBanner.vue?vue&type=script&setup=true&lang=js"

import "./MyBanner.vue?vue&type=style&index=0&id=31a5ba61&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b3655c94b52f2edce08bd59b38cc948d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a5ba61"]])

export default __exports__